import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@blueprintjs/core";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
export default connectToEditor((editorState) => {
  return {
    disabled: !(editorState.sequenceDataHistory && editorState.sequenceDataHistory.past && editorState.sequenceDataHistory.past.length)
  };
})(({ toolbarItemProps, undo, disabled }) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { "data-test": "veUndoTool", icon: "undo" }),
        disabled,
        onIconClick: undo,
        tooltip: /* @__PURE__ */ jsxs("span", { children: [
          "Undo ",
          /* @__PURE__ */ jsx("span", { style: { fontSize: 10 }, children: "(Cmd/Ctrl+Z)" })
        ] }),
        ...toolbarItemProps
      }
    }
  );
});
